import React from 'react';
import { Box, Heading } from '@hover/blueprint';
import SignUpCTAForm from '../signup-cta-form';

const DownloadAppModalContentDesktop: React.FC = () => (
  <Box
    d={{ base: 'none', tablet: 'flex' }}
    maxW="xl"
    py={500}
    borderRadius="8px"
    flexDir="column"
    alignItems="flex-start"
  >
    <Heading size={{ tablet: 600, desktop: 700 }} isLight>
      Your first job is free
    </Heading>
    <Heading size={500} isDisplay marginBottom={800}>
      HOVER makes home improvement simpler, faster and more collaborative for
      homeowners and pros.
    </Heading>
    <SignUpCTAForm
      inputBackground="neutral.100"
      inputColor="brandNavy.600"
      contentColor="neutral.600"
      linkColorScheme="primary"
    />
  </Box>
);

export default DownloadAppModalContentDesktop;
